import React, { useState } from "react";
import { Paper, Text, Title, Grid, Group, Button, Radio, Alert, Loader } from "@mantine/core";
import { djangoAxiosInstance } from "../../../api";

const TenantSettingsSection = ({ tenant }) => {
  if (!tenant) return null;
  const [defaultComparison, setDefaultComparison] = useState(tenant.default_comparison.join());
  const [updateStatus, setUpdateStatus] = useState(null);
  const handleSaveTenant = async () => {
    setUpdateStatus(
        {state: "loading"}
    )
    try {
      const accessToken = localStorage.getItem("access_token");
      const headers = {};
      if (accessToken) {
        headers["Authorization"] = `Bearer ${accessToken}`;
      }

      const response = await djangoAxiosInstance.put(
        `/tenants/`,
        {
          default_comparison: defaultComparison.split(",")
        },
        { headers }
      );

      if (response.status === 200) {
        setUpdateStatus({
          state: "success",
          message: "Tenant was successfully updated."
        });

      } else {
        throw new Error(`Unexpected response status: ${response.status}`);
      }
    } catch (err) {

      setUpdateStatus({
        state: "error",
        message:
          err.response?.data?.message ||
          "Failed to update tenant. Please try again.",
        defaultComparison: err.response?.data?.default_comparison || null
      });
    }
    };
  return (
    <Paper shadow="xs" mt="lg" p="md" withBorder>
      <Title order={2} mb="md">
        Settings
      </Title>
        {updateStatus && (
            <Alert
            title={updateStatus.state == "success" ? "Success" : updateStatus.state == "loading" ? "Loading" : "Error"}
            color={updateStatus.state == "success" ? "green" : updateStatus.state == "loading" ? "blue" : "red"}
            mb="md"
            withCloseButton
            onClose={() => setUpdateStatus(null)}
            closeButtonLabel="Close"
            >
              {updateStatus.state == 'loading' ? (
                  <Loader color="blue"/>
              ) : (updateStatus.message)}
            </Alert>
        )}
      <Grid>
        <Grid.Col span={12}>
          <Text fw={500}>Default Comparisons</Text>
          <Radio.Group
          value={defaultComparison}
          onChange={setDefaultComparison}
          error={updateStatus?.defaultComparison ? updateStatus.defaultComparison : null}
          >
            <Group justify="space-between">
              <Radio value={'litera'} label="Litera Compare Only"/>
              <Radio value={'word'} label="Word Tracked Changes Only"/>
              <Radio value={'word,litera'} label="Litera Compare + Word Tracked Changes"/>
            </Group>
          </Radio.Group>
        </Grid.Col>
      </Grid>
      <Group justify="flex-end" mt="md">
        <Button
          color="green"
          onClick={() => {handleSaveTenant()}}>
          Save
        </Button>
      </Group>
    </Paper>
  );
};

export default TenantSettingsSection;
